import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../../../config/api";
import { BASE_API } from "../../../../../constants/apiUrls";
import { toast } from "../../../../../lib/toast";
import {
  ErrorMessage,
  GetCommonData,
  Params,
  PostRequest,
} from "../../../../../types";
import { ContributionData } from "../../../../../types/webCms/aboutUs/contribution";

// get all
export const getAllContributionAsync = createAsyncThunk<
  GetCommonData<ContributionData>,
  Params<any>,
  {
    rejectValue: ErrorMessage;
  }
>("admin/getAllContribution", async ({ params }, { rejectWithValue }) => {
  try {
    const data = await AXIOS.get(BASE_API.getHomeContribution);

    return {
      data: data.data?.data,
      length: data.data?.totalCount,
    };
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    toast("error", error?.message || "Get fail");
    return rejectWithValue(error);
  }
});

// update
export const updateContributionAsync = createAsyncThunk<
  null,
  PostRequest<ContributionData, any>
>(
  "admin/updateContribution",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      await AXIOS.patch(`${BASE_API.updateHomeContribution}`, data);

      reRender && reRender(true);
      toast("success", "update successfully");
      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      toast("error", error?.message || "update fail");
      return rejectWithValue(error);
    }
  }
);
